import FileUpload from '~/scripts/services/model/file-upload';

export default class Observation extends FileUpload {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {?(File | any)} [file] File object
	 * @param {?string} [name]
	 */
	constructor($injector, file = null, name = null) {
		super($injector, file, name);
		this.edit = false;
		this.comment = '';
		this.previousValues = {
			name: '',
			comment: '',
		};
	}
}
